// @flow

import _ from 'lodash';
import ApiObject from '../ApiObject';

import GmapUtils from '../../utils/GmapUtils';

export default class UserAddress extends ApiObject {

  id: string;

  /**
   * the number and the name of the street
   * @type string
   */
  street:	string;

  /**
   * some more information (ie building, floor, apt #)
   * @type string
   */
  complement:	string;

  /**
   * The city
   * @type string
   */
  city: string;

  /**
   * The zip code
   */
  postCode: string;

  /**
   * The country (full name)
   */
  country: string;

  /**
   * More instructions like digicode, ringtone, etc)
   */
  instructions: string;

  /**
   * a label describing this address (Home, Work, ...)
   */
  name:	string;

  /**
   * @type string
   */
  phoneNumber: string;

  geoPt: GeoPt;

  formattedAddress: string;

  getLiteral(): string {
    if (!_.isEmpty(this.street)
      && !_.isEmpty(this.city)
    ) {
      let literal = `${this.street}, ${this.city}`;
      if (!_.isEmpty(this.country)) {
        literal += `, ${this.country}`;
      }
      return literal;
    } else if (!_.isEmpty(this.formattedAddress)) {
      return this.formattedAddress
    }

    return null
  }

  fromLatitudeAndLongitude(latitude, longitude, formattedAddress) {
    this.geoPt = {
      longitude,
      latitude,
    }
    this.formattedAddress = formattedAddress;
  }

  fromGeolocatorLocation(geolocatorLocation: GeolocatorLocation) {

    if (!_.isNil(geolocatorLocation.address)) {
      this.street = `${geolocatorLocation.address.streetNumber} ${geolocatorLocation.address.street}`;
      this.city = geolocatorLocation.address.town; // city give Paris-8E-Arrondissement ..
      this.postCode = geolocatorLocation.address.postalCode;
      this.country = geolocatorLocation.address.country;
    }

    if (!_.isNil(geolocatorLocation.coords)) {
      this.geoPt = {
        longitude: geolocatorLocation.coords.longitude,
        latitude: geolocatorLocation.coords.latitude,
      };
    }
  }

  fromGmapAddressComponents(addressComponents: GmapAddressComponents, geometry: GmapGeometry = null) {
    const streetNumberComponent = GmapUtils.getTypeOnGmapAddressComponents('street_number', addressComponents);

    const streetNameComponent = GmapUtils.getTypeOnGmapAddressComponents('route', addressComponents);

    this.street = `${streetNumberComponent.long_name} ${streetNameComponent.long_name}`;

    this.city = GmapUtils.getTypeOnGmapAddressComponents('locality', addressComponents).short_name;

    this.postCode = GmapUtils.getTypeOnGmapAddressComponents('postal_code', addressComponents).long_name;

    this.country = GmapUtils.getTypeOnGmapAddressComponents('country', addressComponents).long_name;

    if (!_.isNil(geometry)) {
      this.geoPt = {
        longitude: geometry.location.lng(),
        latitude: geometry.location.lat(),
      };
    }
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/user/UserAddress.js